"use client";

import GetDeliveryLocationDetails from "@/app/components/GetDeliveryLocationDetails";
import CustomFacet from "@/app/search/facets/customFacet";
import style from "./baseSearchPage.module.scss";
import purchasedBeforeStyles from "./facets/facetBar.module.scss";

const ResultsAdditionalContent = () => {
  return (
    <>
      <div className={style.additionalContentContainer}>
        <GetDeliveryLocationDetails />
      </div>
      <div className={style.bottomContent}>
        <CustomFacet
          id="purchasedBefore"
          name="Purchased Before"
          hoverText="Shows products you’ve purchased before."
          requireAuth
          className={purchasedBeforeStyles.purchasedBeforeContainer}
        />
      </div>
    </>
  );
};

export default ResultsAdditionalContent;
